import React from 'react';
import PropTypes from 'prop-types';
import { getFlightTypeText } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/constants';
import HintButton from 'src/components/HintButton';
import PlaneIcon from '@lt/components/icons-react/rebrand/Plane';
import { useSelector } from 'react-redux';
import { getOperatorId } from 'src/routes/Checkout/store/selectors/package';
import { FlightTypePropTypes } from '../../proptypes/flights';

const FlightType = ({
  type,
  showFlightClass,
  showIcon,
  showDescription,
  showPluralTitle,
  showTooltip,
}) => {
  const { flightType, flightClass } = type;

  const operatorID = useSelector(getOperatorId);
  const { title, pluralTitle, tooltipDescription, tooltipTitle } =
    getFlightTypeText(flightType, { operatorID });

  return (
    <>
      {showIcon && (
        <span>
          <PlaneIcon height={14} />{' '}
        </span>
      )}
      {showPluralTitle ? pluralTitle : title}
      {showFlightClass ? <span>, {flightClass}</span> : <span>.</span>}
      {showDescription && <span> {tooltipDescription}</span>}
      {showTooltip && tooltipTitle && (
        <span>
          {' '}
          <HintButton text={tooltipTitle} />
        </span>
      )}
    </>
  );
};

FlightType.propTypes = {
  type: FlightTypePropTypes.isRequired,
  showIcon: PropTypes.bool,
  showDescription: PropTypes.bool,
  showFlightClass: PropTypes.bool,
  showPluralTitle: PropTypes.bool,
  showTooltip: PropTypes.bool,
};

FlightType.defaultProps = {
  showIcon: true,
  showTooltip: true,
  showDescription: true,
  showFlightClass: false,
  showPluralTitle: false,
};

export default FlightType;
